module.exports = window.xP = window.expromptum = require('./lib');



/*****************
 ** WEBPACK FOOTER
 ** ./expromptum.js
 ** module id = 0
 ** module chunks = 0
 **/